module.exports = __webpack_public_path__ + "img/fossil3Img1.bb6d7c49.jpg";